import { axios } from '@/plugins/axios.js'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchOfficialReceipts(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/official_receipts', { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchOfficialReceipt(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/api/v1/official_receipts/${params.id}`, { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    createOfficialReceipt(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .post('api/v1/official_receipts', params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updateOfficialReceipt(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .put(`api/v1/official_receipts/${params.id}`, params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    voidOfficialReceipt(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/api/v1/official_receipts/${params.id}`, { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchInvoices(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/official_receipts/debtor_invoices', { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  }
}